import { defineComponent as _defineComponent } from 'vue'
import { TanStackDevtoolsCore } from '@tanstack/devtools';
import { useQueryClient } from '@tanstack/vue-query';
import Vue, { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import BookNParkDevtoolsPanel from './BookNParkDevtoolsPanel.vue';
import VueQueryDevtoolsPanel from './VueQueryDevtoolsPanel.vue';
import { useConfigStore } from '@gms/stores/src/stores/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'DevTools',
  setup(__props) {

const configStore = useConfigStore()
const isDevEnvironment = computed(() => configStore?.config?.isDev ?? false)

const devtoolsContainer = ref<null|HTMLElement>(null);
const client = useQueryClient();
const devtools = new TanStackDevtoolsCore({
  config: {
    // Choose a different default hotkey, because default is Shift+a, which is bad for text inputs
    openHotkey: ['Alt', 'a'],
  },
  plugins: [
    {
      id: 'bnp',
      name: 'Book-n-Park',
      render(el, theme) {
        const panel = Vue.extend(BookNParkDevtoolsPanel);
        const instance = new panel({ propsData: { }});
        instance.$mount();
        el.replaceChildren(instance.$el);
      },
    },
    {
      name: 'TanStack Query',
      render(el, theme) {
        const panel = Vue.extend(VueQueryDevtoolsPanel);
        const instance = new panel({ propsData: { client }});
        instance.$mount();
        el.replaceChildren(instance.$el);
      }
    }
  ],
});
onMounted(() => {
  if(devtoolsContainer.value) {
    devtools.mount(devtoolsContainer.value);
  }
})
onBeforeUnmount(() => {
  if(devtoolsContainer.value) {
    devtools.unmount()
  }
})

return { __sfc: true,configStore, isDevEnvironment, devtoolsContainer, client, devtools }
}

})